import { gql } from '@apollo/client';
const ADD_VARIANTS = gql `
  mutation AddVariants($productId: ID!, $variants: [VariantToAddIn]!) {
    addVariants(productId: $productId, variants: $variants)
  }
`;
export default ADD_VARIANTS;
